import {DesignSystem, DesignSystemEasing} from "../../../engine/_interfaces/designSystem";

const params: DesignSystemEasing = {
  neutral: 'linear',
  standard: 'easeInOutQuart',
  accelerate: 'easeInQuart',
  decelerate: 'easeOutQuart',
};

const designSystem: DesignSystem = {
  _NAME: 'EasingJs',
  params,
};

export default designSystem;
